<div class="container">
  <mic-breadcrumb id="casing-grade-table-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingGradeTableText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title" id="casing-grade-heading">{{ translationService.translate('casingGradeTableText') }}</h2>

  <div class="action-bar">
    <button
      id="reset-filters"
      class="btn-clear"
      type="button"
      mat-flat-button
      color="accent"
      (click)="clearFilters()"
      [disabled]="isDeleting"
    >
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearFiltersText') }}
    </button>
    <button
      id="save"
      class="btn-primary"
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="isDeleting"
      [matTooltip]="productSaveDisabled ? this.translationService.translate('comingSoonText') : null"
      (click)="createCasingGrade()"
    >
      <mat-icon>save</mat-icon>
      {{ translationService.translate('createButtonText') }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          id="gradeDropdown"
          formControlName="casingGradeTableCodes"
          [data]="codesList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectGradeText') }}"
          label="{{ translationService.translate('casingGradeSearchCodeText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>
        <mic-dropdown-search
          micDropdownAccessibility
          id="descDropdown"
          formControlName="casingGradeTableDescriptions"
          [data]="descriptionList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectDescText') }}"
          label="{{ translationService.translate('casingGradeSearchDescriptionText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>
      </div>
    </form>
  </mat-card>

  <div id="product-casing-grade-table" class="cam-table table-container">
    <mic-table appCopyOnSelect #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>

      <ng-container id="table-menu" *micTableRowMenu="let item">
        <button
          id="delete-button"
          type="button"
          [disabled]="!(item | isDeletable) || isDeleting"
          mat-menu-item
          (click)="deleteCasingGradeTable(item)"
        >
          <mat-icon>delete</mat-icon> {{ translationService.translate('deleteText') }}
        </button>
        <button id="copy-button" type="button" [disabled]="isDeleting" mat-menu-item (click)="copyCasingGradeTable(item)">
          <mat-icon>content_copy</mat-icon> {{ translationService.translate('copyText') }}
        </button>
        <button
          [disabled]="this.productSaveDisabled || isDeleting"
          id="assign-to-customer-button"
          type="button"
          mat-menu-item
          (click)="assignToCustomer(item)"
        >
          <mat-icon>person_add_alt</mat-icon> {{ translationService.translate('assignToCustomerMenuText') }}
        </button>
      </ng-container>
    </mic-table>
  </div>
</div>
